import React, { useState } from 'react';

// Assets
import booklaunchImg from '../assets/booklaunch.jpg';
import eidAdhaImg from '../assets/eid_adha.jpg';
import eidFitrImg from '../assets/eid_fitr.jpg';
import websitelaunchImg from '../assets/websitelaunch.jpg';
import marriageImg from '../assets/marriage.jpg';
import operatingImg from '../assets/operating.jpg';


const Events = () => {
  const [activeTab, setActiveTab] = useState('all'); // 'all' | 'upcoming' | 'past'

  const eventsData = [
    {
      id: 1,
      title: 'Marriage Presentation',
      date: 'August 2, 2026',
      time: '11:00 AM IST',
      location: 'Main Conference Hall / Zoom',
      category: 'Presentation',
      status: 'upcoming',
      isFeatured: true,
      image: marriageImg,
      description: 'A comprehensive community overview and discussion on family marriage guidelines, match support networks, and trust initiatives designed to empower young couples.',
    },
    {
      id: 2,
      title: 'Confidence Interval Book Launch Event',
      date: 'Early 2026',
      location: 'Trust Hall & Digital Release',
      category: 'Publication',
      status: 'past',
      image: booklaunchImg,
      description: 'Official release and community distribution event for the Confidence Interval publication, highlighting analytical insights and educational foundations.',
    },
    {
      id: 3,
      title: 'Eid al-Adha Gathering',
      date: 'May 26, 2026',
      location: 'Trust Grounds',
      category: 'Celebration',
      status: 'past',
      image: eidAdhaImg,
      description: 'Annual community prayer assembly, celebratory feast, and welfare distribution of food packages across family households.',
    },
    {
      id: 4,
      title: 'Eid al-Fitr Celebration',
      date: 'March 19 - 20, 2026',
      location: 'Main Center',
      category: 'Celebration',
      status: 'past',
      image: eidFitrImg,
      description: 'Special congregation prayers, community breakfast, and the official kickoff of our seasonal fundraising and youth drive.',
    },
    {
      id: 5,
      title: 'Official Website Launch',
      date: 'April 2026',
      location: 'Digital Portal',
      category: 'Milestone',
      status: 'past',
      image: websitelaunchImg,
      description: 'Official debut of the MBA Trust web application featuring automated donation portals, interactive calendar schedules, and grievance tracking.',
    },
    {
      id: 6,
      title: 'Operating Manual Release',
      date: 'Early 2026',
      location: 'Trust Archives',
      category: 'Governance',
      status: 'past',
      image: operatingImg,
      description: 'Publication and formal rollout of the standardized operational guidelines and governance manuals for all MBA Trust members.',
    },
  ];

  const featuredEvent = eventsData.find((e) => e.isFeatured);
  
  const filteredEvents = eventsData.filter((event) => {
    if (activeTab === 'upcoming') return event.status === 'upcoming';
    if (activeTab === 'past') return event.status === 'past';
    return true;
  });

  return (
    <div className="min-h-screen bg-[#EBDCCD] py-16 px-4 sm:px-8 lg:px-16 font-serif text-[#2C1A14]">
      <div className="max-w-6xl mx-auto space-y-14">
        
        {/* HEADER SECTION */}
        <div className="text-center space-y-4 max-w-2xl mx-auto">
          <span className="text-xs font-black uppercase tracking-[0.35em] text-[#2C1A14]/70 bg-[#D4B896]/30 px-4 py-1.5 rounded-full border border-[#2C1A14]/10 inline-block">
            MBA Trust Directory
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#2C1A14]">
            Events & Milestones
          </h1>
          <p className="text-stone-700 text-base sm:text-lg leading-relaxed font-sans">
            Explore key milestone events, family gatherings, and community developments shaping our initiative.
          </p>
        </div>

        {/* FEATURED UPCOMING EVENT HERO CARD */}
        {featuredEvent && (
          <div className="relative overflow-hidden bg-[#FFFBF7] rounded-3xl border-2 border-[#2C1A14] shadow-2xl transition-all">
            <div className="absolute top-0 right-0 z-20 bg-[#2C1A14] text-[#EBDCCD] text-xs font-extrabold uppercase px-5 py-2 rounded-bl-2xl tracking-widest shadow-md">
              ★ Next Highlight Event
            </div>

            <div className="flex flex-col lg:flex-row items-stretch">
              {/* Featured Event Image Container */}
              {featuredEvent.image && (
                <div className="lg:w-1/2 relative min-h-[300px] bg-[#1c120c] overflow-hidden flex items-center justify-center p-4">
                  <img
                    src={featuredEvent.image}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover blur-xl opacity-30 scale-125"
                  />
                  <img
                    src={featuredEvent.image}
                    alt={featuredEvent.title}
                    className="relative z-10 max-h-[360px] w-auto max-w-full object-contain rounded-xl shadow-lg"
                  />
                </div>
              )}

              {/* Event Info */}
              <div className="p-8 sm:p-10 lg:w-1/2 flex flex-col justify-between space-y-6">
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <span className="text-xs font-bold bg-[#EBDCCD] text-[#2C1A14] px-3.5 py-1.5 rounded-full border border-[#D4B896]/60">
                      {featuredEvent.category}
                    </span>
                    <span className="text-xs font-semibold text-rose-800 bg-rose-100 px-3 py-1 rounded-full border border-rose-200">
                      Upcoming Event
                    </span>
                  </div>

                  <h2 className="text-3xl sm:text-4xl font-bold text-[#2C1A14] leading-tight">
                    {featuredEvent.title}
                  </h2>

                  <p className="text-stone-700 text-base sm:text-lg leading-relaxed font-sans">
                    {featuredEvent.description}
                  </p>
                </div>

                <div className="pt-6 flex flex-wrap gap-6 text-sm font-semibold text-stone-800 border-t border-[#D4B896]/40 font-sans">
                  <div className="flex items-center gap-2">
                    <span className="text-lg">📅</span>
                    <span>{featuredEvent.date}</span>
                  </div>
                  {featuredEvent.time && (
                    <div className="flex items-center gap-2">
                      <span className="text-lg">⏰</span>
                      <span>{featuredEvent.time}</span>
                    </div>
                  )}
                  <div className="flex items-center gap-2">
                    <span className="text-lg">📍</span>
                    <span>{featuredEvent.location}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* NAVIGATION TABS */}
        <div className="flex justify-center border-b border-[#D4B896]/60 pb-6">
          <div className="inline-flex p-1.5 bg-white/70 backdrop-blur-md rounded-2xl border border-[#D4B896]/50 shadow-md gap-2">
            <button
              onClick={() => setActiveTab('all')}
              className={`px-6 py-2.5 text-xs font-bold uppercase tracking-wider rounded-xl transition ${
                activeTab === 'all'
                  ? 'bg-[#2C1A14] text-[#EBDCCD] shadow-md'
                  : 'text-[#2C1A14]/70 hover:text-[#2C1A14]'
              }`}
            >
              All Events ({eventsData.length})
            </button>
            <button
              onClick={() => setActiveTab('upcoming')}
              className={`px-6 py-2.5 text-xs font-bold uppercase tracking-wider rounded-xl transition ${
                activeTab === 'upcoming'
                  ? 'bg-[#2C1A14] text-[#EBDCCD] shadow-md'
                  : 'text-[#2C1A14]/70 hover:text-[#2C1A14]'
              }`}
            >
              Upcoming ({eventsData.filter((e) => e.status === 'upcoming').length})
            </button>
            <button
              onClick={() => setActiveTab('past')}
              className={`px-6 py-2.5 text-xs font-bold uppercase tracking-wider rounded-xl transition ${
                activeTab === 'past'
                  ? 'bg-[#2C1A14] text-[#EBDCCD] shadow-md'
                  : 'text-[#2C1A14]/70 hover:text-[#2C1A14]'
              }`}
            >
              Past Milestones ({eventsData.filter((e) => e.status === 'past').length})
            </button>
          </div>
        </div>

        {/* MAIN EVENTS GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-10">
          {filteredEvents.map((event) => {
            const isPast = event.status === 'past';

            return (
              <div
                key={event.id}
                className={`overflow-hidden rounded-3xl border transition-all duration-300 flex flex-col justify-between ${
                  isPast
                    ? 'bg-white/80 border-[#D4B896]/50 shadow-lg hover:shadow-xl'
                    : 'bg-white border-[#2C1A14]/30 shadow-xl hover:shadow-2xl'
                }`}
              >
                {/* Event Image Box - Fits all aspect ratios perfectly */}
                {event.image && (
                  <div className="h-64 sm:h-72 w-full relative overflow-hidden bg-[#1c120c] border-b border-[#D4B896]/30 flex items-center justify-center p-3">
                    {/* Ambient blurred backdrop */}
                    <img
                      src={event.image}
                      alt=""
                      className="absolute inset-0 w-full h-full object-cover blur-xl opacity-30 scale-125"
                    />
                    
                    {/* Full contained image */}
                    <img
                      src={event.image}
                      alt={event.title}
                      className="relative z-10 max-h-full w-auto max-w-full object-contain rounded-lg shadow-md hover:scale-[1.02] transition-transform duration-300"
                    />

                    {/* Category badge */}
                    <div className="absolute bottom-3 left-4 z-30">
                      <span className="text-[11px] font-bold text-[#2C1A14] bg-[#EBDCCD] px-3 py-1 rounded-full uppercase tracking-wider shadow">
                        {event.category}
                      </span>
                    </div>
                  </div>
                )}

                <div className="p-7 sm:p-8 flex-1 flex flex-col justify-between space-y-6">
                  <div className="space-y-3">
                    <div className="flex justify-between items-center">
                      <span
                        className={`text-xs font-bold px-3 py-1 rounded-full ${
                          isPast
                            ? 'bg-stone-200 text-stone-700'
                            : 'bg-emerald-100 text-emerald-800'
                        }`}
                      >
                        {isPast ? 'Completed' : event.date}
                      </span>
                      {isPast && (
                        <span className="text-xs font-semibold text-stone-500 font-sans">
                          {event.date}
                        </span>
                      )}
                    </div>

                    <h3 className="text-2xl font-bold text-[#2C1A14]">
                      {event.title}
                    </h3>

                    <p className="text-stone-700 text-sm sm:text-base leading-relaxed font-sans">
                      {event.description}
                    </p>
                  </div>

                  <div className="pt-4 border-t border-stone-200/80 flex justify-between items-center text-xs sm:text-sm text-stone-600 font-sans font-medium">
                    <span className="flex items-center gap-1.5">
                      📍 {event.location}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {filteredEvents.length === 0 && (
          <div className="text-center py-16 bg-white/50 rounded-3xl border border-[#D4B896]/40">
            <p className="text-stone-600 text-base italic font-sans">
              No events match the selected category.
            </p>
          </div>
        )}

      </div>
    </div>
  );
};

export default Events;